import { Link } from "react-router-dom";
import { Bell, Coins } from "lucide-react";
import { MOCK_NOTIFICATIONS } from "@/lib/mockData";
import { useAuth } from "@/lib/AuthContext";
import Logo from "@/components/Logo";

const TopHeader = () => {
  const { user, guest } = useAuth();
  const unread = MOCK_NOTIFICATIONS.filter((n) => n.unread).length;

  return (
    <header
      className="sticky top-0 z-30 bg-[#F8F9FA]/85 backdrop-blur-md border-b-2 border-[#0A0A0A]"
      data-testid="top-header"
    >
      <div className="max-w-2xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/feed" data-testid="logo-link">
          <Logo size={36} />
        </Link>

        <div className="flex items-center gap-2">
          {user && (
            <Link
              to="/tokens"
              className="flex items-center gap-1.5 brutal-border rounded-full bg-[#FFFBEB] px-3 py-1.5 brutal-shadow-sm"
              data-testid="token-pill"
            >
              <Coins className="w-4 h-4" />
              <span className="font-mono font-bold text-sm">{user.tokens}</span>
            </Link>
          )}
          <Link
            to="/notifications"
            className="relative w-10 h-10 brutal-border rounded-full bg-white brutal-shadow-sm flex items-center justify-center"
            data-testid="notifications-bell"
          >
            <Bell className="w-4 h-4" />
            {user && unread > 0 && (
              <span
                className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-[#FF6A2C] border-2 border-white text-white font-bold text-[10px] flex items-center justify-center"
                data-testid="notifications-unread-count"
              >
                {unread}
              </span>
            )}
          </Link>
          {guest && !user && (
            <Link
              to="/register"
              className="brutal-btn bg-[#0A0A0A] text-white px-3 py-1.5 text-xs"
              data-testid="header-signup-btn"
            >
              Sign up
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default TopHeader;
